import React, { useState, useMemo, useEffect, useContext } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { AiOutlineCloudUpload } from 'react-icons/ai'

import api from '../../services/api'
import StoreContext from '../storage/context'
import TableCard from '../tableCard/index.js'
import NavigationBar from '../navigationBar/index.js'
import AlertCustom from '../alertCustom/index.js'
import ManualFileUploadForm from '../manualFileUploadForm/index.js'
import errorHandlerShow from '../errorHandlerShow/index.js'

import './styles.css'

// define a pagina de pesquisa dos cadastro arquivos manuais
const ManualFileUpload = () => {
    const { pk_user, givenName, pk_service, token, setToken } = useContext(StoreContext);

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'cadastro arquivos manuais',
            'link': `/cadastro-arq-manual`
        },
        {
            'nome': 'upload',
            'link': '/cadastro-arq-manual/upload'
        }
    ]

    const [lgShow, setLgShow] = useState(false);
    const [metadata, setMetadata] = useState([]);

    // state for display alert to users
    const [alert, setAlert] = useState({ header: '', message: '', type: '', options_btn: [] });
    const [showAlert, setShowAlert] = useState(false);

    const [selectedData, setSelectedData] = useState([]);
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        api.get('manual-file/metadata', {
            params: { 'pk_user': pk_user },
            headers: { 'Authorization': token }
        }).then(response => {
            setMetadata(response.data.control_metadata)
            setLoading(false)
        })
            .catch(error => {
                errorHandlerShow(error, setToken, setAlert, setShowAlert)
            })
    }, []);

    let data = useMemo(() => metadata
        .filter((item) => { return item.metadata.email_notification_account.split(";").concat(item.metadata.fk_user).includes(pk_user) })
        .map((item, index) => (
            {
                id: item.metadata.pk_metadata,
                version: item.control.version,
                fileName: item.metadata.entity_name,
                obs: item.control.desc_validation,
                status: item.control.validation_status,
                authorizers: item.metadata.email_notification_account.split(";").concat(item.metadata.fk_user),
                delimiter: item.metadata.delimiter,
                area_for_business_data: item.metadata.area_for_business_data,
                extension_file: item.metadata.extension_file,
                encoding: item.metadata.encoding,
                project_name: item.control.project_name
            }
        )))

    const handleClickGroup = (values, action) => {
        setLgShow(true)
        if (action === 'upload') {
            setSelectedData(values)
        }
    }

    const checkIfApproved = (row) => {
        const approval_status = row.values.status

        // allow only 'Aprovação Final'
        if (approval_status === 'Aprovação Final') {
            handleClickGroup(row.original, 'upload')
        } else {
            setAlert({
                header: 'Operação não autorizada',
                message: "Apenas arquivos manuais previamente aprovados, ou seja, com o status de 'Aprovação Final', podem ser enviados.",
                type: 'danger',
                options_btn: []
            })
            // show alert with mensage
            setLgShow(false)
            setShowAlert(true)
        }

    }

    const columns = useMemo(
        () => [
            {
                Header: '#',
                accessor: 'id', // accessor is the "key" in the data
            },
            {
                Header: 'Versão',
                accessor: 'version',
            },
            {
                Header: 'Nome do arquivo',
                accessor: 'fileName',
            },
            {
                Header: 'Observações da validação',
                accessor: 'obs',
            },
            {
                Header: 'Status da validação',
                accessor: 'status'
            },
            {
                width: 100,
                Header: "Ações",
                Cell: ({ value, column, row }) => (
                    <div className='mf-search-actions'>
                        {row.original.authorizers.includes(pk_user) ?
                            <AiOutlineCloudUpload size={20} onClick={() => checkIfApproved(row)} />
                            : null}

                    </div>
                )
            }
        ],
        []
    )

    return (
        <div className="mf-search-container">
            {/* BARRA DE NAVEGAÇÃO */}
            <NavigationBar navegation={navegation} />

            {/* ALERT CUSTOM */}
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            {loading === true ?
                <Spinner animation="border" role="status" />
                : null}
            {
                columns.length > 0 && loading != true ?
                    <TableCard data={data} columns={columns} />
                    : loading != true ? <h4>Nenhum Arquivo Cadastrado</h4> : null
            }
            {/* formulario com dados do solicitante e governança */}
            <Modal
                dialogClassName="mfs-main-modal"
                // fullscreen={true}
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Faça o upload do arquivo {selectedData.fileName}.{selectedData.extension_file}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {/* FORMS */}
                    <ManualFileUploadForm
                        setAlert={setAlert}
                        setShowAlert={setShowAlert}
                        setLgShow={setLgShow}
                        fileName={selectedData.fileName}
                        fileId={selectedData.id}
                        delimiter={selectedData.delimiter}
                        area_for_business_data={selectedData.area_for_business_data}
                        extensionFile={selectedData.extension_file}
                        encoding={selectedData.encoding}
                        selectedData={selectedData}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ManualFileUpload;